import gql from 'graphql-tag';

export const InstitutionSet = gql`
    fragment InstitutionSet on InstitutionSet {
        profileImage {
            ...ProfileImage
        }
        institutionSetId
        siteType
        title
    }
`;
